export default __webpack_public_path__ + "8fb0e7a154c62d539dc7c2d53b3fb8ed.png";